import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { PipeAll, PipeStatuses } from '../models';

export function useGetAllPipesWithObj() {
  const initial: { pipesWithObj: Record<string, PipeStatuses> } = {
    pipesWithObj: {}
  };

  const { data = initial, ...arg } = useQuery<{ pipesWithObj: Record<string, PipeStatuses> }>(
    ['PIPES_WITH_OBJ'],
    async () => {
      const { data } = await $api.get('/v1/pipe/all');
      const result: Record<string, PipeStatuses> = {};

      (data?.data as PipeAll[])?.forEach(({ pipeStatuses }, index) => {
        pipeStatuses?.forEach(({ id, ...other }) => {
          result[id || index] = { id, ...other };
        });
      });

      return { pipesWithObj: result };
    }
  );

  return { ...data, ...arg };
}
